import type {Location} from '@smartmixin/core';

/**
 * Where a place opens on the webapp (FE #381 W4): its page, by its device
 * hash — the Google place id (so a shared link resolves anywhere), a point
 * (`pt:…`), or the current location's own hash.
 */
export const placeHref = ({hash}: Pick<Location, 'hash'>) =>
  `/app/places/${encodeURIComponent(hash)}`;
